const taxableStates = ['WA'];

export const isTaxableAddress = ({ state }) => {
  return taxableStates.includes(state);
};
